import script from "./Toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=66a7aca8&lang=scss"

const __exports__ = script;

export default __exports__